import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'wouter';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api.ts';

export function Login() {
  const { t } = useTranslation();
  const [, navigate] = useLocation();
  const qc = useQueryClient();
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    setBusy(true);
    setError(false);
    try {
      await api('/api/auth/login', { method: 'POST', body: { email: f.get('email'), password: f.get('password') } });
      await qc.invalidateQueries({ queryKey: ['me'] });
      navigate('/');
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="card stack narrow" onSubmit={submit}>
      <h1>{t('login.title')}</h1>
      <div className="field"><label htmlFor="email">{t('login.email')}</label><input id="email" name="email" type="email" autoComplete="email" required /></div>
      <div className="field"><label htmlFor="password">{t('login.password')}</label><input id="password" name="password" type="password" autoComplete="current-password" required /></div>
      {error && <p className="error" role="alert">{t('login.error')}</p>}
      <button className="btn" disabled={busy}>{t('login.submit')}</button>
      <Link href="/demo" className="muted">{t('login.tryDemo')}</Link>
    </form>
  );
}
